/**
 * Frosted glass card for auth pages.
 *
 * Aliases: auth card, login card, glass card
 */

import { motion } from "motion/react";
import type { ReactNode } from "react";

interface AuthCardProps {
  readonly children: ReactNode;
}

export function AuthCard({ children }: AuthCardProps) {
  return (
    <motion.div
      className="w-full max-w-[480px] rounded-2xl border border-white/20 bg-background p-6 shadow-2xl backdrop-blur-xl sm:p-8"
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
